import { styled, TableContainer, Table as MuiTable } from "@mui/material";

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  overflow: "auto",
  boxShadow: "none",
  border: `1px solid ${theme.palette.divider}`,
}));

export const StyledMuiTable = styled(MuiTable)({
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& thead tr:first-of-type th": {
    borderTop: "none",
  },
  "& tr th:first-of-type, & tr td:first-of-type": {
    borderLeft: "none",
  },
  "& tr th:last-of-type, & tr td:last-of-type": {
    borderRight: "none",
  },
});
